/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import Loader from "../../../components/loader";
import { Column } from "primereact/column";
import { DataTable, DataTableSortEvent } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import PrimePaginator from "../../../components/prime-paginator";
import { PaginatorPageChangeEvent } from "primereact/paginator";
import { AxiosResponse } from "axios";
import { APIExportSendTBSData, APIGetAllTBSData, APIGetTBSDetails, APIGetTBSStats, APIGetTbsDDl, APIToCreateTBSItem } from "../../../service/api-service";
import { APIResponseEntity } from "../../../interface/api-responce";
import { toast } from "react-toastify";
import { toastOptObj } from "../../../utils/constants";
import { IsStringNullEmptyOrUndefined } from "../../../utils/null-check";
import { GetTBSDetailsResEntity, SendForTBSData, SendForTBSFilterReq, TBSCreatedByDDLEntity, TBSDashboardEntity, TBSOfficeDDLEntity, TBSUserDDLEntity } from "../../../interface/tbs-tracker/send-tbs";
import { checkActionAuthorization, downloadCsvFile } from "../../../service/shared.service";
import UploadTBSImagesModal from "./uploadtbsimagemodel";
import { useLocation, useNavigate } from "react-router-dom";
import { MultiSelect } from "primereact/multiselect";
import { StorageKeyEnum } from "../../../utils/enum";
import { UserInfoEntity } from "../../../interface";
import StatisticsDashboard from "./components/send-tbs-statistics";
import { TBS_STATUS_OPTIONS, getTbsStatusClassName, getTbsStatusLabel } from "../../../utils/tbs-status";
import ReceiverDetailsModal from "./components/receiver-details-modal";
import ReceiverDetailsIcon from "./components/receiver-details-icon";
import { isReceiverReportMatched } from "../../../utils/tbs-verification";

type SendForTBSLocationState = {
    status?: string;
};

function SendForTBS() {
    const navigate = useNavigate();
    const location = useLocation();
    // the "To Be Supply In Transit" red ribbon opens this page already filtered on that status
    const locationState = location.state as SendForTBSLocationState | undefined;
    const initialStatus: string = TBS_STATUS_OPTIONS.some((option) => option.value === locationState?.status) ? String(locationState?.status) : "";
    const officeMultiSelectRef = useRef<any>(null);
    const salesHeadMultiSelectRef = useRef<any>(null);
    const createdByMultiSelectRef = useRef<any>(null);
    const statusMultiSelectRef = useRef<any>(null);
    const [tempOffice, setTempOffice] = useState<string[]>([]);
    const [tempSalesHead, setTempSalesHead] = useState<string[]>([]);
    const [tempCreatedBy, setTempCreatedBy] = useState<string[]>([]);
    const [tempStatus, setTempStatus] = useState<string[]>(initialStatus ? [initialStatus] : []);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isStateLoading, setIsStateLoading] = useState<boolean>(false);
    const [dashboard, setDashboard] = useState<TBSDashboardEntity[]>([]);
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [isUploadModalOpen, setIsUploadModalOpen] = useState<boolean>(false);
    const [selectedTbsForReceiverDetails, setSelectedTbsForReceiverDetails] = useState<SendForTBSData | null>(null);
    const [receiverDetailsData, setReceiverDetailsData] = useState<GetTBSDetailsResEntity | null>(null);
    const [isReceiverDetailsModalOpen, setIsReceiverDetailsModalOpen] = useState<boolean>(false);
    const [rows, setRows] = useState<SendForTBSData[]>([]);
    const [officesAndUsers, setOfficesAndUsers] = useState<TBSOfficeDDLEntity[]>([]);
    const [userDDL, setUserDDL] = useState<TBSUserDDLEntity[]>([]);
    const [createdByUsers, setCreatedByUsers] = useState<TBSCreatedByDDLEntity[]>([]);
    const [visibleOrder, setVisibleOrder] = useState<string>("");
    const [filterReq, setFilterReq] = useState<SendForTBSFilterReq>({
        APICallCount: 0,
        pageNumber: 0,
        pageSize: 10,
        searchByTBSNo: "",
        searchByProjectName: "",
        searchByProjectNo: "",
        filterByOfficeIds: "",
        filterBySalesHeadIds: "",
        filterByCreatedByIds: "",
        searchByLocationCount: "",
        searchBySkin: "",
        searchByHardware: "",
        searchByTotalSqft: "",
        status: initialStatus,
        sortColumn: "tbsNo",
        sortOrder: "desc",
    });

    const fetchTBSList = async (): Promise<void> => {
        setIsLoading(true);
        try {
            const resp: AxiosResponse<APIResponseEntity> = await APIGetAllTBSData(filterReq);

            if (resp) {
                if (resp.data && resp.status === 200) {
                    const axiosResp: APIResponseEntity = resp.data;

                    if (axiosResp && axiosResp.data && axiosResp.status && axiosResp.statusCode === 200) {
                        const paginateResp = axiosResp.data;
                        setRows(paginateResp.data);
                        setTotalRecords(paginateResp.totalCount?.[0]?.count ?? 0);
                    } else {
                        toast.error(axiosResp.message, { ...toastOptObj });
                    }
                } else {
                    toast.error(resp.data?.message || "Failed to fetch TBS list.", {
                        ...toastOptObj,
                    });
                }
            }
        } catch {
            toast.error("Failed to fetch TBS list.", {
                ...toastOptObj,
            });
        }
        finally {
            setIsLoading(false);
        }
    };

    const fetchDashboardStats = async (): Promise<void> => {
        setIsStateLoading(true);

        try {
            const resp: AxiosResponse<APIResponseEntity> = await APIGetTBSStats();

            if (resp) {
                if (resp.data && resp.status === 200) {
                    const axiosResp: APIResponseEntity = resp.data;

                    if (axiosResp && axiosResp.data && axiosResp.status && axiosResp.statusCode === 200) {
                        setDashboard(axiosResp.data);
                    } else {
                        toast.error(axiosResp.message, { ...toastOptObj });
                    }
                } else {
                    toast.error(resp.data?.message || "Failed to fetch dashboard stats.", {
                        ...toastOptObj,
                    });
                }
            }
        } catch {
            toast.error("Failed to fetch dashboard stats.", {
                ...toastOptObj,
            });
        } finally {
            setIsStateLoading(false);
        }
    };

    const fetchOfficeAndUser = async (): Promise<void> => {
        const resp: AxiosResponse<APIResponseEntity> = await APIGetTbsDDl();
        if (resp) {
            if (resp.data && resp.status === 200) {
                const axiosResp: APIResponseEntity = resp.data;
                if (axiosResp && axiosResp.data && axiosResp.status && axiosResp.statusCode === 200) {
                    const ddlData = axiosResp.data[0];
                    setOfficesAndUsers(ddlData.officeSalesPerson);
                    setCreatedByUsers(ddlData.createdByUsers);
                } else {
                    toast.error(axiosResp.message, { ...toastOptObj });
                }
            } else {
                toast.error(resp.data?.message || "Export failed.", {
                    ...toastOptObj,
                });
            }
        }
    };

    const exportSendTBSData = async (): Promise<void> => {
        setIsLoading(true);
        const resp: AxiosResponse<APIResponseEntity> = await APIExportSendTBSData();
        setIsLoading(false);

        if (resp) {
            if (resp.data && resp.status === 200) {
                const axiosResp: APIResponseEntity = resp.data;

                if (axiosResp && axiosResp.data && axiosResp.status && axiosResp.statusCode === 200) {
                    const excelUrl = axiosResp.data.xlsxUrl;
                    if (excelUrl && !IsStringNullEmptyOrUndefined(excelUrl)) {
                        const fileName: string = excelUrl.split("/").pop() as string;

                        if (fileName && !IsStringNullEmptyOrUndefined(fileName)) {
                            await downloadCsvFile(excelUrl, fileName);
                        }
                    }
                } else {
                    toast.error(axiosResp.message, { ...toastOptObj });
                }
            } else {
                toast.error(resp.data?.message || "Export failed.", {
                    ...toastOptObj,
                });
            }
        }
    };

    const handleUploadSuccess = async (
        zoomImage: File | null,
        packingImage: File | null
    ) => {
        try {
            setIsLoading(true);
            const formData = new FormData();
            if (zoomImage) {
                formData.append("zoomPicture", zoomImage);
            }
            if (packingImage) {
                formData.append("packingPicture", packingImage);
            }
            const resp = await APIToCreateTBSItem(formData);
            if (resp && resp.data && (resp.status === 200 || resp.status === 201)) {
                const axiosResp: APIResponseEntity = resp.data;
                if (
                    axiosResp &&
                    axiosResp.data &&
                    (axiosResp.statusCode === 200 || axiosResp.statusCode === 201)
                ) {
                    toast.success(axiosResp.message, { ...toastOptObj });
                    setIsUploadModalOpen(false);
                    const tbsId = axiosResp.data._id;
                    setTimeout(() => {
                        navigate(`/TBS/send-for-tbs-step/${tbsId}`);
                    }, 500);
                    return;
                }
                toast.error(axiosResp.message, { ...toastOptObj });
            }
        } catch {
            toast.error("Failed to upload images.", { ...toastOptObj });
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        // fetchDashboardStats();
        fetchOfficeAndUser();
        const userStr = localStorage.getItem(StorageKeyEnum.JB_GLASS_USER_INFO);

        if (userStr && !IsStringNullEmptyOrUndefined(userStr)) {
            const userInfo: UserInfoEntity = JSON.parse(userStr);
            setVisibleOrder(userInfo.visibleOrders);
        }

        const element = document.querySelector(".pageTop");

        if (element) {
            element.scrollIntoView({
                behavior: "smooth",
                block: "center",
            });
        }
    }, []);

    useEffect(() => {
        if (visibleOrder !== "selfOffice") {
            return;
        }

        if (rows.length === 0 || officesAndUsers.length === 0) {
            return;
        }

        const officeName = rows[0].officeName.trim().toLowerCase();

        const matchedOffice = officesAndUsers.find(
            (office) =>
                office.officeName.trim().toLowerCase() === officeName
        );
        if (!matchedOffice) return;
        setTempOffice([matchedOffice.officeId]);
        setUserDDL(matchedOffice.users);
        setFilterReq((prev) => ({
            ...prev,
            filterByOfficeIds: matchedOffice.officeId,
        }));
    }, [rows, officesAndUsers]);

    useEffect(() => {
        fetchTBSList();
    }, [filterReq.APICallCount]);

    // the ribbon was clicked while this page is already open: apply its status filter now
    useEffect(() => {
        const requestedStatus: string = TBS_STATUS_OPTIONS.some((option) => option.value === locationState?.status) ? String(locationState?.status) : "";
        if (!requestedStatus || requestedStatus === filterReq.status) {
            return;
        }

        setTempStatus([requestedStatus]);
        setFilterReq((prev) => ({
            ...prev,
            status: requestedStatus,
            pageNumber: 0,
            APICallCount: prev.APICallCount + 1,
        }));
    }, [location.key]);

    const resetFilters = (): void => {
        setTempOffice([]);
        setTempSalesHead([]);
        setTempCreatedBy([]);
        setTempStatus([]);
        setUserDDL([]);
        setFilterReq((prev) => ({
            ...prev,
            APICallCount: prev.APICallCount + 1,
            pageNumber: 0,
            pageSize: 10,
            searchByTBSNo: "",
            searchByProjectName: "",
            searchByProjectNo: "",
            filterByOfficeIds: "",
            filterBySalesHeadIds: "",
            filterByCreatedByIds: "",
            searchByLocationCount: "",
            searchBySkin: "",
            searchByHardware: "",
            searchByTotalSqft: "",
            status: "",
            sortColumn: "tbsNo",
            sortOrder: "desc",
        }));

        // the ribbon's status filter is kept in the page state: clear it too, so a refresh does not bring it back
        navigate("/TBS/send-for-tbs", { replace: true, state: {} });
    };

    const tbsBodyTemplate = (rowData: SendForTBSData) => rowData.tbsNo;
    const statusTemplate = (rowData: SendForTBSData) => (
        <span className={`fw-bold ${getTbsStatusClassName(rowData.status)}`}>
            {getTbsStatusLabel(rowData.status)}
        </span>
    );
    const canShowReceiverDetails = (status?: string): boolean => {
        const normalized = (status || "").toLowerCase().trim();
        return ["issued", "semi-issued", "semi issued", "received", "returned"].includes(normalized);
    };

    const canViewSendForTBS = checkActionAuthorization("view", "Send For TBS");
    const canViewReceivedDetails = checkActionAuthorization("View Received Details", "Send For TBS");

    const handleOpenReceiverDetails = async (rowData: SendForTBSData) => {
        if (!rowData?._id) return;
        setIsLoading(true);
        try {
            const resp = await APIGetTBSDetails(rowData._id);
            if (resp && resp.data && resp.status === 200) {
                const apiResp = resp.data;
                if (apiResp && apiResp.statusCode === 200 && apiResp.data) {
                    setReceiverDetailsData(apiResp.data);
                    setSelectedTbsForReceiverDetails(rowData);
                    setIsReceiverDetailsModalOpen(true);
                } else {
                    toast.error(
                        apiResp.message || apiResp.errorMsg || "Unable to fetch TBS receiver details.",
                        { ...toastOptObj }
                    );
                }
            } else {
                toast.error(
                    resp?.data?.message || "Unable to fetch TBS receiver details.",
                    { ...toastOptObj }
                );
            }
        } catch (err: any) {
            toast.error(err?.message || "Failed to fetch receiver details.", {
                ...toastOptObj,
            });
        } finally {
            setIsLoading(false);
        }
    };

    const actionTemplate = (rowData: SendForTBSData) => {
        const showReceiverDetails = canShowReceiverDetails(rowData.status) && canViewReceivedDetails;
        const sendQty = rowData.sendQuantity ?? rowData.sendQty ?? rowData.qty;
        const receiveQty = rowData.receiveQuantity ?? rowData.receivedQty;
        const isMatched = isReceiverReportMatched(sendQty, receiveQty, rowData.hasReceiverChange);

        return (
            <div
                className="d-flex justify-content-center align-items-center"
                style={{ minWidth: "160px", gap: "15px" }}
            >
                {canViewSendForTBS && (
                    <img
                        src="assets/images/eye.svg"
                        alt="View TBS"
                        title="View TBS"
                        className="cursor-pointer"
                        onClick={() => navigate(`/TBS/view-tbs-send-item/${rowData._id}`)}
                    />
                )}
                {showReceiverDetails && (
                    <ReceiverDetailsIcon isMatched={isMatched} onClick={() => handleOpenReceiverDetails(rowData)} />
                )}
            </div>
        );
    };

    const renderInputFilter = (
        field: keyof SendForTBSFilterReq,
        placeholder: string
    ) => (
        <InputText
            value={filterReq[field] as string}
            placeholder={placeholder}
            style={{ minWidth: "180px" }}
            className="w-100"
            onChange={(e) =>
                setFilterReq((prev) => ({
                    ...prev,
                    [field]: e.target.value,
                    pageNumber: 0,
                    APICallCount: prev.APICallCount + 1,
                }))
            }
        />
    );

    const renderMultiSelectFilter = (
        ref: React.RefObject<any>,
        tempValue: string[],
        setTempValue: React.Dispatch<React.SetStateAction<string[]>>,
        options: any[],
        optionLabel: string,
        optionValue: string,
        field: keyof SendForTBSFilterReq,
        onApply?: (value: string[]) => void,
        disabled = false
    ) => {
        const appliedValues =
            typeof filterReq[field] === "string" && filterReq[field]
                ? (filterReq[field] as string).split(",")
                : [];
        const panelFooterTemplate = () => (
            <div className="p-2">
                <button
                    className="p-button p-button-sm"
                    disabled={
                        JSON.stringify(tempValue) ===
                        JSON.stringify(appliedValues)
                    }
                    onClick={() => {
                        onApply?.(tempValue);
                        setFilterReq(prev => ({
                            ...prev,
                            [field]: tempValue.join(","),
                            pageNumber: 0,
                            APICallCount: prev.APICallCount + 1,
                        }));

                        ref.current.hide();
                    }}
                >
                    Apply
                </button>
            </div>
        );
        return (

            <MultiSelect
                ref={ref}
                value={tempValue}
                options={options}
                optionLabel={optionLabel}
                optionValue={optionValue}
                disabled={disabled}
                filter
                placeholder="Select"
                maxSelectedLabels={1}
                panelFooterTemplate={panelFooterTemplate}
                onChange={(e) => setTempValue(e.value)}
                onHide={() => setTempValue(appliedValues)}
            />
        );
    };

    const onTableSort = (e: DataTableSortEvent) => {
        if (e.sortField && e.sortOrder) {
            setFilterReq(prev => ({
                ...prev,
                sortColumn: String(e.sortField),
                pageNumber: 0,
                sortOrder: e.sortOrder === 1 ? "asc" : "desc",
                APICallCount: prev.APICallCount + 1,
            }));
        }
    };

    const onPageChange = (event: PaginatorPageChangeEvent) => {
        setFilterReq(prev => ({
            ...prev,
            pageNumber: event.page,
            pageSize: event.rows,
            APICallCount: prev.APICallCount + 1,
        }));
    };

    const showOfficeColumn = visibleOrder === "all";
    const showSalesHeadColumn = visibleOrder === "all" || visibleOrder === "selfOffice";
    return (
        <>
            <Loader isLoading={isLoading || isStateLoading} />
            <div className="content-wrapper">
                <div className="d-flex justify-content-between align-items-center mb-4 pageTop">
                    <h2 className="fw-bold mb-0">
                        TBS Tracker
                    </h2>
                    <div className="d-flex align-items-center gap-2">
                        {checkActionAuthorization("upgrade", "Export TBS Items") &&
                            <button type="button" className="btn btn-block btn-success btn-md font-weight-medium m-0 ms-2 pull-right"
                                onClick={exportSendTBSData}
                            >
                                Export
                            </button>
                        }
                        {checkActionAuthorization("create", "Send For TBS") &&
                            <button type="button" className="btn btn-block  btn-primary btn-md font-weight-medium m-0"
                                onClick={() => setIsUploadModalOpen(true)}>
                                Upload
                            </button>
                        }
                    </div>
                </div>
                {/* <StatisticsDashboard dashboard={dashboard} /> */}
                <div className="mt-4  bg-white rounded-3 shadow-sm">
                    <div className="d-flex justify-content-end px-3 py-3">
                        <span
                            className="resetFilters text-primary"
                            style={{ cursor: "pointer" }}
                            onClick={resetFilters}
                        >
                            Reset Filters
                        </span>
                    </div>
                    <div className="px-3 pb-3">
                        <DataTable
                            value={rows}
                            filterDisplay="row"
                            responsiveLayout="scroll"
                            className="p-datatable-sm"
                            emptyMessage="No Records Found"
                            rowGroupMode="rowspan"
                            groupRowsBy="tbsNo"
                            lazy
                            sortField={filterReq.sortColumn}
                            sortOrder={filterReq.sortOrder === "asc" ? 1 : -1}
                            onSort={onTableSort}
                        >
                            <Column
                                field="tbsNo"
                                header="TBS No."
                                sortable
                                filter
                                showFilterMenu={false}
                                filterElement={() =>
                                    renderInputFilter("searchByTBSNo", "Search TBS No.")
                                }
                                body={tbsBodyTemplate}
                            />
                            <Column
                                field="projectName"
                                header="Project Name"
                                sortable
                                filter
                                showFilterMenu={false}
                                filterElement={() =>
                                    renderInputFilter("searchByProjectName", "Search Project Name")
                                }
                            />
                            <Column
                                field="projectNo"
                                header="Project No."
                                sortable
                                filter
                                showFilterMenu={false}
                                filterElement={() =>
                                    renderInputFilter("searchByProjectNo", "Search Project No.")
                                }
                            />
                            {showOfficeColumn &&
                                <Column
                                    field="officeName"
                                    header="Office Name"
                                    sortable
                                    filter
                                    showFilterMenu={false}
                                    filterElement={() =>
                                        renderMultiSelectFilter(
                                            officeMultiSelectRef,
                                            tempOffice,
                                            setTempOffice,
                                            officesAndUsers,
                                            "officeName",
                                            "officeId",
                                            "filterByOfficeIds",
                                            (selectedOfficeIds: string[]) => {
                                                const users = officesAndUsers
                                                    .filter((office) =>
                                                        selectedOfficeIds.includes(office.officeId)
                                                    )
                                                    .flatMap((office) => office.users);

                                                setUserDDL(users);
                                                setTempSalesHead([]);

                                                setFilterReq((prev) => ({
                                                    ...prev,
                                                    filterBySalesHeadIds: "",
                                                }));
                                            }
                                        )
                                    }
                                />}
                            {showSalesHeadColumn &&
                                <Column
                                    field="salesHead"
                                    header="Order Sales Head"
                                    sortable
                                    filter
                                    showFilterMenu={false}
                                    filterElement={() =>
                                        renderMultiSelectFilter(
                                            salesHeadMultiSelectRef,
                                            tempSalesHead,
                                            setTempSalesHead,
                                            userDDL,
                                            "displayName",
                                            "salesPersonId",
                                            "filterBySalesHeadIds",
                                            undefined,
                                            !filterReq.filterByOfficeIds
                                        )
                                    }
                                />}
                            <Column
                                field="tbsCreatedBy"
                                header="TBS CreatedBy"
                                sortable
                                filter
                                showFilterMenu={false}
                                filterElement={() =>
                                    renderMultiSelectFilter(
                                        createdByMultiSelectRef,
                                        tempCreatedBy,
                                        setTempCreatedBy,
                                        createdByUsers,
                                        "createdByName",
                                        "createdById",
                                        "filterByCreatedByIds"
                                    )
                                }
                            />
                            <Column
                                field="locationCount"
                                header="Location Count"
                                sortable
                                filter
                                showFilterMenu={false}
                                filterElement={() =>
                                    renderInputFilter("searchByLocationCount", "Search")
                                }
                            />
                            <Column
                                field="skin"
                                header="Skin"
                                sortable
                                filter
                                showFilterMenu={false}
                                filterElement={() =>
                                    renderInputFilter("searchBySkin", "Search")
                                }
                            />
                            <Column
                                field="hardware"
                                header="Hardware"
                                sortable
                                filter
                                showFilterMenu={false}
                                filterElement={() =>
                                    renderInputFilter("searchByHardware", "Search")
                                }
                            />

                            <Column
                                field="totalSqft"
                                header="Total Sqft."
                                sortable
                                filter
                                showFilterMenu={false}
                                filterElement={() =>
                                    renderInputFilter("searchByTotalSqft", "Search")
                                }
                            />
                            {/* field "tbsNo" keeps the status merged across the order rows of one TBS (like TBS No. and Action); it sorts on the status itself */}
                            <Column
                                field="tbsNo"
                                sortField="status"
                                header="TBS Status"
                                body={statusTemplate}
                                sortable
                                filter
                                showFilterMenu={false}
                                filterElement={() =>
                                    renderMultiSelectFilter(
                                        statusMultiSelectRef,
                                        tempStatus,
                                        setTempStatus,
                                        TBS_STATUS_OPTIONS,
                                        "label",
                                        "value",
                                        "status"
                                    )
                                }
                                style={{ minWidth: "160px" }}
                            />
                            {(canViewSendForTBS || canViewReceivedDetails) &&
                                <Column
                                    field="tbsNo"
                                    header="Action"
                                    body={actionTemplate}
                                    style={{
                                        minWidth: "180px",
                                        textAlign: "center",
                                    }}
                                />}
                        </DataTable>
                        {totalRecords > 0 &&
                            <PrimePaginator
                                onPageChange={onPageChange}
                                pageNumber={filterReq.pageNumber}
                                pageSize={filterReq.pageSize}
                                totalRecords={totalRecords}
                            />}
                    </div>

                    <UploadTBSImagesModal
                        isOpen={isUploadModalOpen}
                        onClose={() => setIsUploadModalOpen(false)}
                        onSave={handleUploadSuccess}
                    />

                    <ReceiverDetailsModal
                        isOpen={isReceiverDetailsModalOpen}
                        onClose={() => {
                            setIsReceiverDetailsModalOpen(false);
                            setSelectedTbsForReceiverDetails(null);
                            setReceiverDetailsData(null);
                        }}
                        viewData={receiverDetailsData}
                        tbsId={selectedTbsForReceiverDetails?._id}
                        tbsNo={receiverDetailsData?.tbsNumber || selectedTbsForReceiverDetails?.tbsNo}
                    />
                </div>
            </div>
        </>
    );
}

export default SendForTBS;